import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Form, Button, Input, Col, Checkbox, Row, InputNumber } from "antd";
import { FormInstance } from "antd/lib/form";
import SelectInput from "../../../core/ui/components/SelectInput";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
const FormFields = {
  ID: "id",
  ORGANISATION_INDEX_CATEGORY_ID: "organisationIndexCategoryId",
  CASE_LAW_DOCUMENT_TYPE_CODE: "documentTypeId",
  MAX_LENGTH: "maxLength",
  VALID: "valid",
  REQUIRED: "required"
};
const CaseLawDocumentTypeCategoryAssignationForm = ({
  translate,
  form,
  rowData,
  organisationIndexCategories,
  caseLawDocumentTypeCode
}: {
  translate: any;
  form: FormInstance;
  rowData?: any;
  organisationIndexCategories: IOrganisationIndexCategory[];
  caseLawDocumentTypeCode?: number;
}) => {
  form.setFieldsValue({ fields: rowData?.fields });
  return (
    <Form layout={"vertical"} form={form}>
      <Form.List name="fields">
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((field, index) => (
                <Row
                  key={field.key}
                  gutter={16}
                  className={"content-section-modal-emphasize"}
                >
                  <Col sm={24} xs={24}>
                    <Form.Item
                      name={[index, FormFields.ID]}
                      initialValue={rowData && rowData.fields[index]?.id}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={[index, FormFields.CASE_LAW_DOCUMENT_TYPE_CODE]}
                      initialValue={
                        (rowData && rowData.fields[index]?.documentTypeId) ??
                        caseLawDocumentTypeCode
                      }
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col lg={12} md={9} sm={12} xs={24}>
                    <Form.Item
                      label={translate(
                        "editors.case_law_document_types_index_organisations.index_category"
                      )}
                      className={"mb-0"}
                      name={[index, FormFields.ORGANISATION_INDEX_CATEGORY_ID]}
                      initialValue={
                        rowData &&
                        rowData.fields[index]?.organisationIndexCategoryId
                      }
                      rules={[
                        {
                          required: true,
                          message: translate(
                            "editors.case_law_document_types_index_organisations.required_messages",
                            {
                              field: translate(
                                "editors.case_law_document_types_index_organisations.index_category"
                              )
                            }
                          )
                        }
                      ]}
                    >
                      <SelectInput
                        placeholder={translate(
                          "editors.case_law_document_types_index_organisations.select_index_category"
                        )}
                        allowClear
                        showSearch={true}
                        notFoundContent={translate("search.no_data")}
                        selectOptionKey={"id"}
                        selectOptionValue={"name"}
                        selectOptions={organisationIndexCategories}
                      />
                    </Form.Item>
                  </Col>
                  <Col lg={6} md={7} sm={12} xs={24}>
                    <Form.Item
                      label={translate(
                        "editors.case_law_document_types_index_organisations.max_value"
                      )}
                      name={[index, FormFields.MAX_LENGTH]}
                      className={"mb-0"}
                      initialValue={rowData && rowData.fields[index]?.maxLength}
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col
                    lg={2}
                    md={3}
                    sm={4}
                    xs={5}
                    style={{
                      display: "flex",
                      marginTop: 20,
                      alignItems: "center"
                    }}
                  >
                    <Form.Item
                      className={"png-form-item-horizontal-checkbox "}
                      label={translate(
                        "editors.case_law_document_types_index_organisations.valid"
                      )}
                      name={[index, FormFields.VALID]}
                      valuePropName={"checked"}
                      initialValue={
                        (rowData && rowData.fields[index]?.valid) ?? true
                      }
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>
                  <Col
                    lg={3}
                    md={4}
                    sm={5}
                    xs={5}
                    style={{
                      display: "flex",
                      marginTop: 10,
                      alignItems: "center"
                    }}
                  >
                    <Form.Item
                      label={translate(
                        "editors.case_law_document_types_index_organisations.required"
                      )}
                      className={"png-form-item-horizontal-checkbox mb-0"}
                      name={[index, FormFields.REQUIRED]}
                      valuePropName={"checked"}
                      initialValue={
                        (rowData && rowData.fields[index]?.required) ?? false
                      }
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>
                  <Col
                    lg={1}
                    md={1}
                    sm={4}
                    xs={4}
                    style={{
                      display: "flex",
                      marginTop: 10,
                      alignItems: "center"
                    }}
                  >
                    <Button
                      danger
                      onClick={() => remove(field.name)}
                      size="small"
                      type={"link"}
                    >
                      <i
                        className={"fas fa-trash-alt"}
                        style={{ marginRight: 0 }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              ))}
              <Row className={"content-section-modal-borderless pb-0"}>
                <Col sm={24} xs={24} style={{ textAlign: "center" }}>
                  <Form.Item className={"mb-0"}>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      style={{ width: "60%" }}
                    >
                      <PlusOutlined />
                      {translate(
                        "editors.case_law_document_types_index_organisations.add_new_index_category"
                      )}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </>
          );
        }}
      </Form.List>
    </Form>
  );
};

export default CaseLawDocumentTypeCategoryAssignationForm;
